<template>
  <div class="main">
    <div>
      <h2 class="locked-drop-label">
        Please enter your email address<br>
        to view this item.
      </h2>
    </div>
    <div>
      <rails-b-form inline @submit.prevent="submitForm" ref="form">
        <label class="sr-only" for="input-email">Email</label>
        <b-form-input
          type="email"
          name="email"
          placeholder="Email address"
          id="input-email"
          class="input-email"
          v-model="email"
        ></b-form-input>
        <b-button
          type="submit"
          variant="primary"
          class="button-email"
        >
          Unlock
        </b-button>
      </rails-b-form>
    </div>
  </div>
</template>

<script>
import RailsBForm from "@/src/components/rails_b_form.vue";

export default {
  components: { RailsBForm },
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      email: ""
    }
  },
  computed: {
    verifyEmailUrl: function() {
      return (this.type == "collection" ? this.$root.routes.verify_email_collection_path(this.id) : this.$root.routes.viewer_verify_email_path(this.id));
    },
    linkedItemUrl: function() {
      return (this.type == "collection" ? this.$root.routes.collection_path(this.id) : this.$root.routes.viewer_view_item_path(this.id));
    }
  },
  methods: {
    submitForm() {
      const vm = this;
      const url = vm.verifyEmailUrl;

      vm.$refs.form.submit(url).then((response) => {
        const token = response.data.token;
        let params = new URLSearchParams("")
        let path = vm.linkedItemUrl;

        params.append("et", token);
        if (response.data.email) {
          params.append("email", response.data.email);
        }
        path = path + "?" + params.toString();
        window.location = path;
      }).catch((error) => {
        console.error(error);
        vm.$root.toastError(error?.response?.data?.message || error?.message || "Something went wrong");
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "application.scss";

.main {
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: rgb(33, 37, 41);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
}

h2.locked-drop-label {
  font-size: 2rem;
  font-weight: 300;
  line-height: 38.4px;
  margin-bottom: 32px;
  margin-top: 0px;
  text-align: center;
  color: var(--gray);
}

.input-email {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.button-email {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
